import React from 'react';
import {IRoutableModule} from '../../router/routing.infra';
import {revokeAccountRouteLoader} from './revoke-account.loader';

const RevokeAccountView = () => null;

export default {
    loader: revokeAccountRouteLoader,
    Component: RevokeAccountView
} as IRoutableModule;
